<template>
  <svg :class="iconClass" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  size?: 'sm' | 'md' | 'lg'
  class?: string
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md',
  class: 'text-body',
})

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-4 w-4 lg:h-5 lg:w-5',
  lg: 'h-6 w-6',
}

const iconClass = computed(() => `${sizeClasses[props.size]} ${props.class}`)
</script>
